import React, { useContext } from 'react'
import { injectIntl, FormattedHTMLMessage } from 'gatsby-plugin-intl';
import Modal from 'react-modal';
import styled from 'styled-components';
import Context from "./context/ModalContext";
import { device } from "./device";


import { CloseBtn } from './styledComponents1';


Modal.setAppElement(`#___gatsby`);

const modalStyles = {
    overlay: {
        alignItems: "center",
        display: "flex",
        flexWrap: 'wrap',
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.58)",
        padding: '0 8px',
        overflowY: "auto",
        width: "100%",
        zIndex: '10001'
    },
    content: {
        borderRadius: "8px",
        maxWidth: "416px",
        margin: "32px auto",
        padding: 0,
        border: 0,
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'relative',
        width: '100%'
    }
};

const ModalContainer = styled.div`
    padding: 0 32px 64px;
    position: relative;
`;
const ModalHeader = styled.div`
    align-items: center;
    display: flex;
    padding-left: 32px;
`;
const ModalLogo = styled.div`
    font-size: 0;
    margin-bottom: 64px;
    text-align: center;
`;
const ModalSubTitle = styled.div`
    margin-bottom: 36px;
    font-size: 16px;
    font-weight: 300;
`;
const FormMessage = styled.div`
    margin-bottom: 24px;
    text-align: center;
    font-size: 24px
`;
const LinkBlock = styled.div`
    display: flex;
    justify-content: center;
    margin: 0 auto;
    width: 100%;
    text-align: center;
    font-size: 14px;
    font-weight: 500;

    background: transparent;
    border: 0;
    cursor: pointer;
    a {
        position: relative;

        align-items: center;
        display: flex;
        height: 32px;
        justify-content: center;
        padding: 0 24px;
        width: fit-content;

        background: var(--green1);
        color: var(--brand);
        border: 0;
        border-radius: 24px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        line-height: 1px;
        outline: 0;
        text-decoration: none;
        transition: background .1s ease-in-out;
        &:hover {
            background: var(--green2);
            color: var(--brand);
            text-decoration: none;
        }
        @media ${device.lg} {
            padding: 0 32px;
        }
    }
`;
const FormBlock = styled.div`
    margin: 0 auto;
    max-width: 400px;
`;

const ModalBlock = ({ intl }) => {
    const modalContext = useContext(Context);
    const closeModal = () => {
        modalContext.updateModalMode();
    };
    return (
        <Context.Consumer>
        {context => (
        <Modal
            isOpen={context.data.modalMode}
            onRequestClose={context.updateModalMode}
            style={modalStyles}
            contentLabel="Modal">
            <ModalHeader>
                <CloseBtn onClick={() => closeModal()} />
            </ModalHeader>
            <ModalContainer>
                <ModalLogo>
                    <svg width="57" viewBox="0 0 76 32" xmlns="http://www.w3.org/2000/svg"><path d="M6.441 1.666L7.677 12.07l27.905 12.028V32L1.806 14.3 0 0l6.441 1.666zm63.135 0L76 0l-1.628 14.3L40.758 32v-7.902L68.502 12.07l1.074-10.404zm-4.465 1.18l-.505 7.147-26.44 9.904-26.518-9.904-.584-7.147 27.102 6.999 26.945-7z" fill="#181818" fillRule="evenodd"/></svg>
                </ModalLogo>
                
                <FormBlock>
                    <FormMessage>{intl.formatMessage({ id: 'modal_welcome' })}</FormMessage>
                    <ModalSubTitle>{intl.formatMessage({ id: 'modal_subtitle' })}</ModalSubTitle>
                    <LinkBlock><FormattedHTMLMessage id="become_partner_btn" /></LinkBlock>
                </FormBlock>
            </ModalContainer>
                
        </Modal>
        )}
        </Context.Consumer>
    )
};

export default injectIntl(ModalBlock);